/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import type { SafeString } from "@ember/template/-private/handlebars";
import Component from "@glimmer/component";
import type { BufferedChangeset } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import { bioExamPrescriptionContentFromParams } from "../../utils/prescription-helpers";

import styles from "./index.module.css";

interface Signature {
  Args: {
    changeset: BufferedChangeset;
  };
}

export default class BioExamPrescriptionPreviewFormComponent extends Component<Signature> {
  styles = styles;

  @service declare intl: IntlService;
  @service declare store: Store;

  get prescriptionAldContent(): SafeString {
    const validityPeriod = parseInt(this.args.changeset.get("validityPeriod"));
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + validityPeriod);

    return htmlSafe(
      bioExamPrescriptionContentFromParams(
        this.args.changeset.get("occurredAt"),
        endDate,
        this.args.changeset.get("exams"),
        this.args.changeset.get("frequency"),
        this.args.changeset.get("customOrders"),
        this.args.changeset.get("aldRelatedComments"),
        this.intl,
        this.store
      ).replace(/\n/gm, "<br />")
    );
  }
}
